import type { ReactNode } from "react";
import { normalizeBackgroundImageUrl } from "@/lib/landing/media/background-image";
import { normalizeBackgroundColor } from "@/lib/landing/puck/styled-text";

type LandingSectionBgProps = {
  backgroundImageUrl?: string;
  backgroundColor?: string;
  children: ReactNode;
  className?: string;
};

/** Фон секции: цвет блока и/или картинка S3 поверх содержимого. */
export function LandingSectionBg({
  backgroundImageUrl,
  backgroundColor,
  children,
  className = "",
}: LandingSectionBgProps) {
  const url = normalizeBackgroundImageUrl(backgroundImageUrl);
  const color = normalizeBackgroundColor(backgroundColor);
  if (!url && !color) {
    return <>{children}</>;
  }

  return (
    <div
      className={`relative ${color ? "[&>*]:bg-transparent" : ""} ${className}`.trim()}
      style={color ? { backgroundColor: color } : undefined}
    >
      {url ? (
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 z-0 bg-cover bg-center bg-no-repeat opacity-40"
          style={{ backgroundImage: `url("${url.replace(/"/g, '\\"')}")` }}
        />
      ) : null}
      <div className="relative z-[1]">{children}</div>
    </div>
  );
}
